import styled from '@emotion/styled';
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import MuiDivider from '@mui/material/Divider';
import spacing from '@mui/system/spacing';

export const Divider = styled(MuiDivider)(spacing);
export const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
